import MarketDealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/MarketDealsTable';
import { getEmMarketColumns } from '@/creditflowresearch/ui/components/deals/DealListTable/columns/EmMarketColumns';

const EmMarketDealsTable = (props) => (
  <MarketDealsTable
    columns={ getEmMarketColumns() }
    { ...props }
  />
);

export default EmMarketDealsTable;
